import {SessionStatusUpdater} from "@kaspernj/api-maker"

// Spawns an updater which keeps looping and refreshing the session
SessionStatusUpdater.current()
